exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-handle[data-v-4f9f7ad2] {\n  cursor: grab;\n  display: inline-block;\n  min-width: 5%;\n}", ""]);

// exports
